<div class="navblock">
  <button (click)="openCreateModal()" class="btnadd">{{'Add route'|translate}}</button>
  <div class="inputgroup">
    <input class="searchinput" type="text" placeholder="{{'Find by name' | translate }}" [(ngModel)]="nameFilter"
           (input)="onTermChange($event)"/>
  </div>
</div>
<div class="tablewrap admindrivers">
  <div class="table">
    <table fixedcols="[0, 2]" id="exporttable">
      <tr>
        <th>
            <switch-all-checkbox [items]="objects | groupFilter : filter" />
        </th>
        <th>{{'Name'|translate}}</th>
        <th>{{'Description'|translate}}</th>
        <th>&nbsp;</th>
      </tr>
      <tr *ngFor="let route of objects | groupFilter : filter">
        <td>
          <input type="checkbox" [(ngModel)]="route.IsChecked"/>
        </td>
        <td>{{route.Name}}</td>
        <td>{{route.Comment}}</td>
        <td>
          <button class="btn_img btn_edit" (click)="openEditModal(route)"></button>
          <button class="btn_img btn_trush " (click)="deleteObject(route.Id)"></button>
        </td>
      </tr>
    </table>
  </div>
</div>
<app-footer-component (onDeleteSelected)="deleteSelected()" [items]="objects | groupFilter : filter"></app-footer-component>
<template #mgmtDialog></template>
